import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Box, Button, Collapse, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import axios from 'src/axios';
import { APICONSTANTS, CONSTANTS } from 'src/components/Constants';
import { SgAccessContext } from 'src/components/manage-users/SgAcessProvider';
import { useAutoTranslation } from 'src/hooks/useTranslate';
function FhqReviewBanner({
  probandId,
  onReview,
  patient = false,
  enabled: featureEnabled = true
}) {
  const t = useAutoTranslation();
  const { allow } = useContext(SgAccessContext);
  const [status, setStatus] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  const fhqAllowed = allow('fhqs');
  const enabled = !!probandId && !patient && fhqAllowed && featureEnabled;

  const fetchStatus = useCallback(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    axios
      .get(APICONSTANTS.getProbandFhqStatus.replace(':probandId', probandId))
      .then((res) => {
        if (!cancelled) setStatus(res.data);
      })
      .catch(() => {
        if (!cancelled) setStatus(null);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled, probandId]);

  useEffect(() => {
    setDismissed(false);
    setStatus(null);
    return fetchStatus();
  }, [fetchStatus]);

  if (!enabled || !status) return null;

  const needsReview =
    status.fhqStatus === CONSTANTS.fhqStatus.SUBMITTED &&
    !!status.canApply &&
    !status.autoApply;

  if (!needsReview) return null;

  const message = t('Questionnaire submitted — needs review');

  return (
    <Collapse in={!dismissed} unmountOnExit>
      <Box
        sx={{
          padding: '12px 16px',
          pointerEvents: 'auto',
          borderRadius: '8px',
          border: '1px solid #e2e8f0',
          backgroundColor: '#ffffff',
          boxShadow: '0 2px 8px rgba(0,0,0,0.12)'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
          <WarningAmberIcon
            sx={{ color: '#8a5a00', fontSize: 18, flexShrink: 0 }}
          />
          <Typography
            title={message}
            sx={{
              minWidth: 0,
              flex: 1,
              fontSize: '0.8rem',
              fontWeight: 600,
              color: '#7a4f00',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
          >
            {message}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 0.5, mt: 0.75 }}>
          <Button
            size="small"
            variant="contained"
            onClick={onReview}
            sx={{
              fontSize: '0.68rem',
              py: 0.1,
              minWidth: 'auto',
              backgroundColor: '#8a5a00',
              '&:hover': { backgroundColor: '#6d4700' }
            }}
          >
            {t('Review')}
          </Button>
          <Button
            size="small"
            variant="text"
            onClick={() => setDismissed(true)}
            sx={{
              fontSize: '0.68rem',
              py: 0.1,
              minWidth: 'auto',
              color: '#8a5a00'
            }}
          >
            {t('Dismiss')}
          </Button>
        </Box>
      </Box>
    </Collapse>
  );
}

export default FhqReviewBanner;
